export const updatePasswordMutation = `
  mutation UpdatePasswordMutation($code: String!, $email: String!, $password: String!){
    UpdateUserPassword(code: $code,email: $email, password: $password){
      success
    }
  }
`;


